import { render } from "./ToneStat.vue?vue&type=template&id=2b708832&scoped=true"
import script from "./ToneStat.vue?vue&type=script&lang=js"
export * from "./ToneStat.vue?vue&type=script&lang=js"

import "./ToneStat.vue?vue&type=style&index=0&id=2b708832&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b708832"]])

export default __exports__